export const GET_LOCAL_AD_BALANCES = 'GET_LOCAL_AD_BALANCES'
export const GET_LOCAL_AD_BALANCES_FULFILLED = 'GET_LOCAL_AD_BALANCES_FULFILLED'
export const GET_LOCAL_AD_BALANCES_REJECTED = 'GET_LOCAL_AD_BALANCES_REJECTED'
/**
 * Trigger epic to get local ads balances
 * @param {{invitationIds: number[]}} payload
 */
export const getLocalAdBalances = (payload) => ({
  type: GET_LOCAL_AD_BALANCES,
  payload,
})
